import { Networks } from './blockchain';

const LOCAL = {
    DAI_ADDRESS: '0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9',
    BASH_ADDRESS: '0xa513E6E4b8f2a923D98304ec87F64353C4D5C853',
    SBASH_ADDRESS: '0x2279B7A0a67DB372996a5FaB50D91eAA73d2eBe6',
    WSBASH_ADDRESS: '0x8A791620dd6260079BF849Dc5567aDC3F2FdC318',
    BASH_BONDING_CALC_ADDRESS: '0x7969c5eD335650692Bc04293B07F5BF2e7A673C0', // todo: bondingCalculator? fuckit.js:60
    TREASURY_ADDRESS: '0x610178dA211FEF7D417bC0e6FeD39F05609AD788',
    STAKING_ADDRESS: '0xA51c1fc2f0D1a1b8494Ed1FE312d7C3a78Ed91C0',
    STAKING_HELPER_ADDRESS: '0x0DCd1Bf9A1b36cE34237eEaFef220932846BCD82',
    DAO_ADDRESS: '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266', // "0x000000000000000000000000000000000000dead",
    ZAPIN_ADDRESS: '',
    REDEEM_ADDRESS: '', // SnowbankFinalRedistribution - https://docs.snowbank.finance/events/final-redistribution -
    BASH_DAI_LP_ADDRESS: '', //Pool
    ATBASH_PRESALE_ADDRESS: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
    PRESALE_REDEMPTION_ADDRESS: '',
};

const MAINNET = {
    ZAPIN_ADDRESS: '',

    ABASH_ADDRESS: '0x56028C51945106a47ECd68258f794a5f9b98d9a6',
    BASH_ADDRESS: '0x5646077E2779a4e8607A99257bD76F627A262d86',
    BASH_BONDING_CALC_ADDRESS: '0x7b83ac0F67F1c829459C226C5d8c66095c00b442',
    BASH_DAI_BOND_ADDRESS: '0x28Da28E466E7e255Fef956878531fd2218c52267',
    BASH_DAI_LP_ADDRESS: '0xA1eB9642CCe9607eb8acD94490C350fe98092cd3',
    DAI_ADDRESS: '0x6b175474e89094c44da98b954eedeac495271d0f',
    DAI_BOND_ADDRESS: '0x464A471A6441Ed592e79F941aD95d07390A41F23',
    DAO_ADDRESS: '0x956769FC9Dae4ae9309990167937Ac6DeF306fBC',
    PRESALE_ADDRESS: '0xB293C23df505C586855678B0c66BE3767ED87B33',
    PRESALE_REDEMPTION_ADDRESS: '0x14fAD9A044BbFF389e6a609e2fa68F83C4B88631',
    REDEEM_ADDRESS: '',
    SBASH_ADDRESS: '0x605d3e1De7896C29A75B4E24E42CA6D1aD703809',
    STAKING_ADDRESS: '0xfd0610C109cb4e0079f801A190FD2dfC6A84aC50',
    STAKING_HELPER_ADDRESS: '0x57DA2292620e69B07cfbFb47E390735Fecc94e40',
    TREASURY_ADDRESS: '0x26FdD9ec526C61A3139ab27bA7775F07964E5EA1',
    WSBASH_ADDRESS: '0x961a96fD2525b1B9dfE400fb96876f7417D68014',
};

const RINKEBY = {
    DAO_ADDRESS: '0x02c368c0787BB33ACAc698049CcA2454B5cC96c5',
    SBASH_ADDRESS: '0x94764A2216688CDccea57AF64880df17d33328E1',
    WSBASH_ADDRESS: '0xa19f7de1c790a3d6bda9905d10f982d533044698',
    BASH_ADDRESS: '0xf7A1D14EC3a45dA9bde66E6b91e68aDc32fa4498',
    DAI_ADDRESS: '0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735',
    STAKING_ADDRESS: '0x89f8ef9714437468eAe11c46a030FDd2a24Beeee',
    STAKING_HELPER_ADDRESS: '0x228A6f8e496940c4799375bE9a9e3eF1249980bb',
    BASH_BONDING_CALC_ADDRESS: '0x4fE972dF6aA2F5f2C1d270e0Ba34C155340bdddb', // daibondCalc: "0xa5381A8345edfafc42EB9946C36f5715083a42c9",
    TREASURY_ADDRESS: '0x73AaDec9511682b1666345a51056900993D5cb8f',
    ZAPIN_ADDRESS: '',
    REDEEM_ADDRESS: '',

    BASH_DAI_LP_ADDRESS: '0xC55C0aD007edaEB867e77d2906C682D99B2C3c23',
    BASH_DAI_BOND_ADDRESS: '0xfabd3f8772474250863C7f0c642Fd1c7704B1caa',
    PRESALE_REDEMPTION_ADDRESS: '0xD11C2412EaBacAE2A8115df31e69FC382330cBe4',
};

export const getAddresses = (networkID: number) => {
    switch (networkID) {
        case Networks.LOCAL:
            return LOCAL;
        case Networks.MAINNET:
            return MAINNET;
        case Networks.RINKEBY:
            return RINKEBY;
        default:
            throw Error("Network don't support");
    }
};
/* 
 * ABASH_ADDRESS: "0x2e05CFB13148bcE832FF8400465326D11ae8dD7F"
BASH_ADDRESS: "0xf7A1D14EC3a45dA9bde66E6b91e68aDc32fa4498"
BASH_BONDING_CALC_ADDRESS: "0x4fE972dF6aA2F5f2C1d270e0Ba34C155340bdddb"
BASH_DAI_BOND_ADDRESS: "0xfabd3f8772474250863C7f0c642Fd1c7704B1caa"
BASH_DAI_LP_ADDRESS: "0xC55C0aD007edaEB867e77d2906C682D99B2C3c23"
DAI_ADDRESS: "0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735"
DAI_BOND_ADDRESS: "0xE6bD71E3acB44814bfED063c75057748bfA94D14"
DAO_ADDRESS: "0x02c368c0787BB33ACAc698049CcA2454B5cC96c5"
PRESALE_ADDRESS: "0xe5946Db5a02Fe8Eadc24aeD0fe322FEaCd2C7924"
PRESALE_REDEMPTION_ADDRESS: "0xD11C2412EaBacAE2A8115df31e69FC382330cBe4"
REDEEM_ADDRESS: ""
SBASH_ADDRESS: "0x94764A2216688CDccea57AF64880df17d33328E1"
STAKING_ADDRESS: "0x89f8ef9714437468eAe11c46a030FDd2a24Beeee"
STAKING_HELPER_ADDRESS: "0x228A6f8e496940c4799375bE9a9e3eF1249980bb"
TREASURY_ADDRESS: "0x73AaDec9511682b1666345a51056900993D5cb8f"
WSBASH_ADDRESS: "0xa19f7dE1C790A3D6bda9905D10F982D533044698"
 */
